import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";

import Box from "./Box";
import ChevronIcon from "../assets/chevron-white.svg";
import PropTypes from "prop-types";
import SquareImage from "./SquareImage";

SwiperCore.use([Navigation]);

function ProductImageSlider({ images, brandImages }) {
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  return (
    <Swiper
      navigation={{
        prevEl: navigationPrevRef.current,
        nextEl: navigationNextRef.current,
      }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
      }}
    >
      {images.map((image) => {
        return (
          <SwiperSlide key={image.url}>
            <Box px="20px">
              <SquareImage src={image.url} alt={image.name} sizes="100vw" />
            </Box>
          </SwiperSlide>
        );
      })}
      {typeof brandImages !== "undefined" &&
        brandImages.map((image) => {
          return (
            <SwiperSlide key={image.url}>
              <Box px="20px">
                <SquareImage
                  src={image.url}
                  alt={image.name}
                  sizes="100vw"
                  objectFit="contain"
                  background="white"
                />
              </Box>
            </SwiperSlide>
          );
        })}
      <div className="swiper-button-prev" ref={navigationPrevRef}>
        <ChevronIcon aria-label="Arrow" />
      </div>
      <div className="swiper-button-next" ref={navigationNextRef}>
        <ChevronIcon aria-label="Arrow" />
      </div>
    </Swiper>
  );
}

export default ProductImageSlider;

ProductImageSlider.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  brandImages: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      width: PropTypes.string.isRequired,
      height: PropTypes.string.isRequired,
    })
  ).isRequired,
};
